import { combineReducers } from "redux-immutable";

import config from "./config";
import webbot from "./webbot";
import webview from "./webview";
import communicationConfig from "./communicationConfig";

export * from "./webbot";

const reducers = {
  config,
  webbot,
  webview,
  communicationConfig,
};

export default combineReducers(reducers);
